// Every user-facing mention of the user's degree routes through here, so a
// DBA or Honorary Doctorate user never reads "PhD" anywhere in the app.
// An unset programme gets the neutral word rather than a guess.
export const programmeLabel = programme => programme || 'Doctoral'
